import { useState } from "react";
import { useEntity, EditDialog, Field } from "./components/crud";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Switch } from "../../components/ui/switch";
import { Pencil, Trash2, Plus } from "lucide-react";

const BLANK = { name: "", slug: "", description: "", image: "", visible: true, sort: 0 };

export default function CategoriesPage() {
  const { items, save, remove } = useEntity("categories");
  const [draft, setDraft] = useState(null);

  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));

  return (
    <div data-testid="admin-categories-page">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Categories</h1>
        <Button data-testid="add-category-btn" onClick={() => setDraft({ ...BLANK, sort: items.length + 1 })}>
          <Plus size={16} className="mr-1" /> Add category
        </Button>
      </div>
      <div className="bg-white border rounded-lg divide-y">
        {items.map((c) => (
          <div key={c.id} className="flex items-center gap-4 px-4 py-3">
            <span className="text-xs text-muted-foreground w-6">{c.sort}</span>
            <div className="flex-1">
              <p className="font-medium text-sm">{c.name}</p>
              <p className="text-xs text-muted-foreground line-clamp-1">{c.description}</p>
            </div>
            <span className={`text-xs px-2 py-0.5 rounded-full ${c.visible ? "bg-emerald-100 text-emerald-700" : "bg-stone-200 text-stone-600"}`}>
              {c.visible ? "Visible" : "Hidden"}
            </span>
            <Button variant="ghost" size="icon" data-testid={`edit-category-${c.slug}`} onClick={() => setDraft(c)}><Pencil size={14} /></Button>
            <Button variant="ghost" size="icon" data-testid={`delete-category-${c.slug}`} onClick={() => window.confirm(`Delete "${c.name}"?`) && remove(c.id)}><Trash2 size={14} /></Button>
          </div>
        ))}
      </div>

      {draft && (
        <EditDialog open title={draft.id ? "Edit category" : "New category"} onClose={() => setDraft(null)}
          onSave={async () => (await save(draft)) && setDraft(null)}>
          <Field label="Name"><Input data-testid="category-name-input" value={draft.name} onChange={(e) => set("name", e.target.value)} /></Field>
          <Field label="Slug"><Input value={draft.slug} onChange={(e) => set("slug", e.target.value)} /></Field>
          <Field label="Description"><Textarea value={draft.description} onChange={(e) => set("description", e.target.value)} /></Field>
          <Field label="Image URL"><Input value={draft.image} onChange={(e) => set("image", e.target.value)} /></Field>
          <div className="flex items-center gap-6">
            <Field label="Visible"><Switch checked={draft.visible} onCheckedChange={(v) => set("visible", v)} /></Field>
            <Field label="Sort"><Input type="number" className="w-20" value={draft.sort} onChange={(e) => set("sort", Number(e.target.value))} /></Field>
          </div>
        </EditDialog>
      )}
    </div>
  );
}
